import React, { useState } from "react";
import {
  Box,
  Paper,
  Grid,
  makeStyles,
  Button,
  Select,
  MenuItem,
  TextField,
  FormControl,
  InputLabel,
  Typography,
  Snackbar,
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import instance, { instanceDPCGC, instanceHotstar } from "api/globalaxios";
import { gethost } from "slices/disputeSlice";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "1.5rem 2rem",
    borderRadius: "8px",
    cursor: "pointer",
  },
  paper2: {
    padding: "1.5rem 2rem",
    borderRadius: "8px",
  },
  headingNew: {
    fontSize: "16px",
    lineHeight: "36px",
    display: "flex",
    alignItems: "center",
    texttransform: "capitalize",
    color: "#4F4F4F",
  },
  bigbtn: {
    fontWeight: "bold",
    fontSize: "24px",
    lineHeight: "36px",
    color: "#FFFFFF",
    textTransform: "none",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
}));

export default function CreateNewLogin({ profiles, clients, opened }) {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();

  const [expand, setExpand] = useState(opened);
  const [close, setClose] = useState(false);
  const [openSnackBar1, setOpenSnackBar1] = useState(false);
  const handleCloseSnackBar1 = () => {
    setOpenSnackBar1(false);
  };
  const [openSnackBar2, setOpenSnackBar2] = useState(false);
  const handleCloseSnackBar2 = () => {
    setOpenSnackBar2(false);
  };
  const [openSnackBar3, setOpenSnackBar3] = useState(false);
  const handleCloseSnackBar3 = () => {
    setOpenSnackBar3(false);
  };
  const [openSnackBar4, setOpenSnackBar4] = useState(false);
  const handleCloseSnackBar4 = () => {
    setOpenSnackBar4(false);
  };
  const [openSnackBar5, setOpenSnackBar5] = useState(false);
  const handleCloseSnackBar5 = () => {
    setOpenSnackBar5(false);
  };

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [client, setClient] = useState("");
  const [profileType, setProfileType] = useState("");

  const onFirstNameChange = (e) => {
    setFirstname(e.target.value);
  };
  const onLastNameChange = (e) => {
    setLastname(e.target.value);
  };
  const onPhoneChange = (e) => {
    setPhone(e.target.value);
  };
  const onEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const onClientChange = (e) => {
    setClient(e.target.value);
  };
  const onProfileChange = (e) => {
    setProfileType(e.target.value);
  };
  const onSubmit = () => {
    if (!firstname || !lastname || !email || !phone || !profileType) {
      setOpenSnackBar3(true);
      // alert("enter details")
    } else {
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (!pattern.test(email)) {
        setOpenSnackBar4(true);
        // alert("enter email correct")
      } else {
        if (phone.length != 10) {
          setOpenSnackBar5(true);
          // alert("enrer phone")
        } else {
          if (client[1] == "Disney+ Hotstar") {
            dispatch(createGuestSignUpHotstarAdmin(profileType)).then(
              () => {
                setClose(true);
              },
              (error) => {
                console.log(error);
              }
            );
          } else {
            try {
              if (client[2].platform) {
                dispatch(createGuestSignUpDpcgcAdmin(profileType)).then(
                  (response) => {
                    setClose(true);
                  },
                  (error) => {
                    console.log(error);
                  }
                );
              } else {
                throw "not dpcgc";
              }
            } catch (err) {
              console.log("error :", err);
              dispatch(createGuestSignUp(profileType)).then(
                (response) => {
                  setClose(true);
                },
                (error) => {
                  console.log(error);
                }
              );
            }
          }
        }
      }
    }
  };

  function createGuestSignUp(profile_type) {
    return async (dispatch) => {
      //   dispatch(setProgress());
      try {
        const response = await instance.post(
          "/customsignup/?host=" + gethost(),
          {
            phone_number: phone,
            profile_type: profile_type,
            company_id: client[0],
            user: {
              email: email,
              password: "Test@123",
              first_name: firstname,
              last_name: lastname,
            },
          },
          {
            headers: {
              "content-type": "application/json",
            },
          }
        );
        setClose(true);
        setOpenSnackBar2(true);
        return response.data;
      } catch (error) {
        console.log(error);
        // alert("ERROR")
        setOpenSnackBar1(true);
      }
    };
  }
  function createGuestSignUpHotstarAdmin(profile_type) {
    return async (dispatch) => {
      //   dispatch(setProgress());
      try {
        const response = await instanceHotstar.post(
          "/customsignup/?host=" + gethost(),
          {
            phone_number: phone,
            profile_type: profile_type,
            company_id: client[0],
            user: {
              email: email,
              password: "Test@123",
              first_name: firstname,
              last_name: lastname,
            },
          },
          {
            headers: {
              "content-type": "application/json",
            },
          }
        );
        setClose(true);
        setOpenSnackBar2(true);
        return response.data;
      } catch (error) {
        console.log(error);
        // alert("ERROR")
        setOpenSnackBar1(true);
      }
    };
  }
  function createGuestSignUpDpcgcAdmin(profile_type) {
    return async (dispatch) => {
      //   dispatch(setProgress());
      try {
        const response = await instanceDPCGC.post(
          "/customsignup/?host=" + gethost(),
          {
            phone_number: phone,
            profile_type: profile_type,
            company_id: client[0],
            user: {
              email: email,
              password: "Test@123",
              first_name: firstname,
              last_name: lastname,
            },
          },
          {
            headers: {
              "content-type": "application/json",
            },
          }
        );
        setClose(true);
        setOpenSnackBar2(true);
        return response.data;
      } catch (error) {
        console.log(error);
        // alert("ERROR")
        setOpenSnackBar1(true);
      }
    };
  }

  return (
    <>
      {!close && (
        <>
          <Grid container justify="center" direction="row">
            <Grid item md={7} sm={9} xs={11}>
              <Paper
                className={expand ? classes.paper2 : classes.paper}
                onClick={(e) => {
                  setExpand(true);
                }}
              >
                <Grid container justify="flex-start">
                  <Grid item>
                    <Typography className={classes.headingNew}>
                      + Create login details
                    </Typography>
                  </Grid>
                </Grid>
                {expand && (
                  <>
                    <Box height="1rem"></Box>
                    <Grid container justify="space-evenly" spacing={3}>
                      <Grid item sm={5} xs={12}>
                        <TextField
                          required
                          id="firstName"
                          name="firstName"
                          label="First Name"
                          variant="outlined"
                          fullWidth={true}
                          value={firstname}
                          onChange={onFirstNameChange}
                        />
                      </Grid>
                      <Grid item sm={5} xs={12}>
                        <TextField
                          required
                          id="lastName"
                          name="lastName"
                          label="Last Name"
                          variant="outlined"
                          fullWidth={true}
                          value={lastname}
                          onChange={onLastNameChange}
                        />
                      </Grid>
                      <Grid item sm={5} xs={12}>
                        <TextField
                          required
                          id="phone"
                          name="phone"
                          label="Phone Number"
                          variant="outlined"
                          type="number"
                          fullWidth={true}
                          value={phone}
                          onChange={onPhoneChange}
                        />
                      </Grid>
                      <Grid item sm={5} xs={12}>
                        <TextField
                          required
                          id="email"
                          name="email"
                          label="Email ID"
                          variant="outlined"
                          fullWidth={true}
                          value={email}
                          onChange={onEmailChange}
                        />
                      </Grid>
                      <Grid item sm={5} xs={12}>
                        <FormControl
                          fullWidth={true}
                          variant="outlined"
                          disabled={clients.length === 0}
                        >
                          <InputLabel id="against">Client Name</InputLabel>
                          <Select
                            id="client_name"
                            name="client_name"
                            value={client}
                            onChange={onClientChange}
                            label="Client Name"
                          >
                            {clients.map((profile, index) => (
                              <MenuItem key={profile} value={profile}>
                                {profile[1]}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item sm={5} xs={12}>
                        <FormControl
                          required
                          fullWidth={true}
                          variant="outlined"
                          disabled={profiles.length === 0}
                        >
                          <InputLabel id="against">Profile type</InputLabel>
                          <Select
                            id="profile_type"
                            name="profile_type"
                            value={profileType}
                            onChange={onProfileChange}
                            label="Profile type"
                          >
                            {profiles.map((profile, index) => (
                              <MenuItem key={profile} value={profile}>
                                {profile}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Box height="2rem"></Box>
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      className={classes.bigbtn}
                      onClick={onSubmit}
                    >
                      Create
                    </Button>
                  </>
                )}
              </Paper>
            </Grid>
          </Grid>
          <Box height="1rem"></Box>
        </>
      )}
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        autoHideDuration={5000}
        open={openSnackBar1}
        onClose={handleCloseSnackBar1}
        message="Problem in creating guest profile."
        // key={vertical + horizontal}
      >
        <Alert onClose={handleCloseSnackBar1} severity="error">
          Problem in creating guest profile.
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        autoHideDuration={5000}
        open={openSnackBar2}
        onClose={handleCloseSnackBar2}
        message="Guest profile is created."
        // key={vertical + horizontal}
      >
        <Alert onClose={handleCloseSnackBar1} severity="success">
          Profile is created.
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        autoHideDuration={5000}
        open={openSnackBar3}
        onClose={handleCloseSnackBar3}
        message="Please enter all the details."
        // key={vertical + horizontal}
      >
        <Alert onClose={handleCloseSnackBar1} severity="warning">
          Please enter all the details.
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        autoHideDuration={5000}
        open={openSnackBar4}
        onClose={handleCloseSnackBar4}
        message="Please enter valid email address."
        // key={vertical + horizontal}
      >
        <Alert onClose={handleCloseSnackBar1} severity="error">
          Please enter valid email address.
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        autoHideDuration={5000}
        open={openSnackBar5}
        onClose={handleCloseSnackBar5}
        message="Please enter valid phone number."
        // key={vertical + horizontal}
      >
        <Alert onClose={handleCloseSnackBar1} severity="error">
          Please enter valid phone number.
        </Alert>
      </Snackbar>
      {expand && (
        <CreateNewLogin profiles={profiles} clients={clients} opened={false} />
      )}
    </>
  );
}
